import axios from "axios";
import { TimflowSteadyRequest } from "../../types/model/calculation";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/calculations/captures`;

export const calculateTimflowSteady = async (
  captureId: number,
  inputId: number,
  payload: TimflowSteadyRequest,
  days: number,
): Promise<any> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.post(`${BASE_URL}/${captureId}/two-layer-whpa/inputs/${inputId}`, payload, {
    params: { days },
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    timeout: Number(process.env.REACT_APP_AXIOS_TIME_OUT),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  return res.data;
};
